module.exports = __webpack_public_path__ + "4c6cbd847093bac6eb80ee69c8e3d6de.pdf";